import { createContext, useContext } from "react";

/** Nothing running. Shared so every idle render hands out the same empty set. */
export const NO_RUNNING_WALKTHROUGH_ANCHORS: ReadonlySet<string> = new Set();

/**
 * The anchor names of the walkthrough running right now; empty when none is.
 *
 * For a control that must look different only while a tour spotlights IT — a hover-only button shown at
 * rest — without changing it for everyone who never starts that tour, or during an unrelated one.
 */
// DEFAULT: empty outside the provider. Only `Layout` mounts `WalkthroughController`, and it provides this
// value around everything it renders, so nothing outside it can be part of a running tour.
export const WalkthroughRunningContext = createContext<ReadonlySet<string>>(NO_RUNNING_WALKTHROUGH_ANCHORS);

/** Whether a running walkthrough has a step on this anchor name. */
export const useIsWalkthroughAnchorActive = (anchor: string): boolean => useContext(WalkthroughRunningContext).has(anchor);

/**
 * Whether any walkthrough is running. For a modal that opens on its own and must yield to a tour rather
 * than sit over its spotlights; what the modal does once the tour is over is the caller's decision.
 */
export const useIsWalkthroughRunning = (): boolean => useContext(WalkthroughRunningContext).size > 0;
